import React from 'react';
import {connect} from 'react-redux';
import SideMenu from '../Presentation/Navigation/SideMenu';
import {Button, TextInput, PasswordInput, EmailInput, FileInput} from '../Presentation/Forms';
import ProfilePic from '../Presentation/ProfilePic';
import SidebarPage from '../Presentation/SidebarPage';
import {updateUserAction, sendInvitation, getUserAction} from '../../actions/User';
import Loader from '../Presentation/Loader';
import ProfileMenu from '../Presentation/Navigation/ProfileMenu';
import config from '../../config';

import {openSuccessPopup, openFailPopup} from '../../actions/Popup';
import {CopyToClipboard} from 'react-copy-to-clipboard';

class ProfilePage extends React.Component {
    constructor(props) {
        super(props);

        this.saveProfile = this.saveProfile.bind(this);
        this.sendInvite = this.sendInvite.bind(this);
        this.refLink = this.buildRefLink();

        this.state = {
            emailError: null,
            passwordRepError: null,
            nameError: null,
            passwordError: null,
            emailInviteError: null,
            linkCopied: false
        };

        document.addEventListener('copy', this.fixRichTextCopy);
    }

    fixRichTextCopy(e) {
        const textContent = e.target.textContent;
        e.clipboardData.setData('text/plain', textContent);
        e.preventDefault();
    }

    componentWillUnmount() {
        document.removeEventListener('copy', this.fixRichTextCopy);
    }

    componentWillReceiveProps(nextProps) {
        this.refLink = this.buildRefLink(nextProps);
    }

    saveProfile(e) {
        e.preventDefault();

        const nameValid = this.refs.name.validate((val) => val.length >= 3, "Името ви трябва да е поне 3 символа");
        const emailValid = this.refs.email.validate();

        if (nameValid && emailValid) {
            let newState = {
                emailError: null,
                passwordRepError: null,
                nameError: null,
                passwordError: null
            };

            const {password, passwordRep, name, email} = this.getInputValues();

            let userData = {
                fullname: name,
                email: email
            };

            if (!name) {
                newState.nameError = "Полето е задължително";
            }

            if (!email) {
                newState.emailError = "Полето е задължително";
            }

            if (password) {
                if (!this.refs.password.validate() || password !== passwordRep) {
                    // Error
                    newState.passwordRepError = "Паролите не съвпадат"
                    this.setState(newState);
                    return false;
                }
                else {
                    userData.plainPassword = password;
                }
            }

            this.setState(newState);
            this.saveUserData(userData);

        }
        return false;
    }

    saveUserData(userData) {
        this.props.dispatch(updateUserAction(this.saveUserData.bind(this, userData), userData))
            .then(data => {
                this.updateUserData();
            })
            .then(data => {
                this.props.dispatch(openSuccessPopup({
                    title: "Успех!",
                    text: "Вашите данни са записани успешно"
                }));
                return data;
            })
            .catch(() => {
                this.props.dispatch(openFailPopup({
                    title: "Грешка",
                    text: "Възникна грешка при записването на вашите данни"
                }));
            });
    }

    updateUserData() {
        this.props.dispatch(getUserAction(this.updateUserData, 'me'));
    }

    getInputValues() {
        return {
            password: this.refs.password ? this.refs.password.getValue() : null,
            passwordRep: this.refs['password-repeat'] ? this.refs['password-repeat'].getValue() : null,
            name: this.refs.name ? this.refs.name.getValue() : null,
            email: this.refs.email ? this.refs.email.getValue() : null,
            inviteEmail: this.refs['invite-email'] ? this.refs['invite-email'].getValue() : null,
        }
    }

    sendInvite(e) {
        e.preventDefault();
        const emailValid = this.refs['invite-email'].validate();

        if (emailValid) {
            const email = this.refs['invite-email'].getValue();
            this.dispatchInvitation({email});
        }

        return false;
    }

    dispatchInvitation(data) {
        this.props.dispatch(sendInvitation(this.dispatchInvitation.bind(this, data), data))
            .then((data) => {
                this.props.dispatch(openSuccessPopup({
                    title: "Поканата е изпратена",
                    text: "Благодарим ти"
                }));
                return data;
            })
            .catch((e) => {
                e.json().then((errData) => {
                    let errorText = "Възникна грешка при изпращането на поканата";

                    //TODO do this differently
                    switch (errData.detail) {
                        case "You cannot send an invitation to yourself.": errorText = "Не можете да поканите себе си."; break;
                        case "User already exists.": errorText = "Вече съществува акаунт с този имейл."; break;
                    }

                    this.props.dispatch(openFailPopup({
                        title: "Грешка",
                        text: errorText
                    }));
                });
            });
    }

    buildRefLink(props = this.props) {
        return `${config.baseUrl}/register?referral=${props.referralCode}`;
    }

    doNothing(e) {
        // e.preventDefault();
    }

    render() {
        const {password, passwordRep, name, email, inviteEmail} = this.getInputValues();
        const {userDataPending, sendInvitationPending} = this.props;
        const sidebar = <SideMenu items={this.props.sideMenu}><ProfileMenu /></SideMenu>;

        let formClass = "profile-form";
        if (userDataPending) formClass += " loading";

        return <SidebarPage sidebar={sidebar} title="Профил">
            <Loader show={userDataPending} />
            <div className={formClass}>
                <div className="row">
                    <div className="col-md-4 col-md-push-8">
                        <ProfilePic/>
                    </div>
                    <div className="col-md-8 col-md-pull-4">
                        <TextInput error={this.state.nameError ? this.state.nameError : null} ref="name" value={name || this.props.name} id="name" name="name" required="required" label="Имена" />
                        <EmailInput error={this.state.emailError ? this.state.emailError : null} disabled={true} ref="email" value={email || this.props.email} id="email" name="email" required="required" label="Имейл адрес" />
                        <PasswordInput ref="password" value={password || ""} id="password" name="password" label="Нова парола" />
                        <PasswordInput error={this.state.passwordRepError ? this.state.passwordRepError : null} ref="password-repeat" value={passwordRep || ""} id="password-repeat" name="password-repeat" label="Повтори новата парола" />
                        <Button clickHandler={this.saveProfile} text="Редактирай"/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 text-center">
                        <Loader show={sendInvitationPending} />
                        <div className={sendInvitationPending ? "loading": ""}>
                            <div className="separator" />

                            <h4>Покани своите приятели в Медита.бг</h4>

                            <div className="cta-text">Изпрати този линк на свои приятели в социалните мрежи или по емайл:</div>
                            <p className="referral-link"><span ref="ref-link">{this.refLink}</span></p>
                            <div>
                                <CopyToClipboard text={this.refLink} onCopy={() => this.setState({linkCopied: true})}>
                                    <button className="btn btn-default clipboard-copy">{this.state.linkCopied ? "Копирано" : "Копирай"}</button>
                                </CopyToClipboard>
                            </div>

                            <h4 className="section-separator-text">или</h4>
                            <div className="cta-text">Директно изпрати емайл от тук</div>

                            <EmailInput className="invite-email" error={this.state.emailInviteError ? this.state.emailInviteError: null}  value={inviteEmail || ""} ref="invite-email" name="invite-email" label="Имейл адрес" />
                            <Button clickHandler={this.sendInvite} text="Покани"/>
                        </div>
                    </div>
                </div>
            </div>
        </SidebarPage>
    }
}

const mapStateToProps = (state) => {
    return {
        name: state.user.userData.fullname,
        email: state.user.userData.email,
        referralCode: state.user.userData.referralCode,
        userDataPending: state.user.userDataPending,
        sendInvitationPending: state.user.sendInvitationPending,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(ProfilePage);



// WEBPACK FOOTER //
// ./src/components/Pages/Profile.js